import { sleep } from "./ui/core/utilities"

import flyd from "flyd"
import filter from "flyd/module/filter"
import debounceTime from "flyd-debouncetime"

const range = (n) => [...Array(n).keys()]
const listChildren = (element) => [...element.children]
const last = (list) => list.slice(-1).first()
const first = (list) => list.first()

// rename canvas to scroller?
const updateState = (state, update) => {
  return {
    ...state,
    ...update,
  }
}

const cushion = 7

const debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export default {
  updatePageCount(state) {
    const pagecount = this.getPageCount()
    // console.error(`setting pagecount: ${pagecount}`)
    return updateState(state, {
      pageSize: pagecount,
    })
  },

  init() {
    const pagecount = this.getPageCount()

    const state = {
      lastCmd: null,
      lastRowStart: null,
      pageSize: pagecount,
      setPreviousPage: false,
      offset: 0,
      time: 0,
    }

    return updateState(state, this.currentIndexes())
  },

  update(msg, state) {
    console.log(`update:`, msg)
    console.log(`update: state:`, state)
    state = this.updatePageCount(state)

    if (msg.type === "unblock") {
      state = updateState(state, {
        block: false,
      })
    }
    switch (msg.type) {
      case "set-last-rowstart":
        state = updateState(state, msg.value)
        break
      case "offset-canvas":
        this.setOffset(state)
        break

      case "next-page":
        state = this.forward(state)
        state = updateState(state, {
          time: msg.time,
          lastCmd: msg.type,
        })
        break
      case "load-previous-page":
        if (state.setPreviousPage === true) {
          state = this.rewind(state)
          state = updateState(state, {
            setPreviousPage: false,
          })
        }
        break

      case "previous-page":
        if (msg.time > state.time) {
          state = this.rewind(state)
          state = updateState(state, {
            setPreviousPage: false,
          })
        }
        state = updateState(state, {
          time: msg.time,
          lastCmd: msg.type,
        })
        break
      case "set-pagecount":
        state = updateState(state, {
          pageSize: msg.value,
        })
        break
      case "set-offset":
        state = updateState(state, {
          offset: msg.value,
        })
        break
      case "keydown":
        switch (msg.key) {
          case "PageDown":
          case "ArrowRight":
            msg.preventDefault()
            msg.stopPropagation
            msg.stopImmediatePropagation()
            // console.log(
            //   `${msg.key}: firstRow: ${state.firstRow} count: ${this.count()}`
            // )
            if (state.firstRow <= this.count()) {
              state = this.scrollPage(state)
              state = updateState(state, {
                lastCmd: msg.key,
              })
            } else {
              state = updateState(state, {
                lastCmd: null,
              })
            }

            break
          case "PageUp":
          case "ArrowLeft":
            msg.preventDefault()
            msg.stopPropagation
            msg.stopImmediatePropagation()

            state = this.rewind(state)
            state = updateState(state, {
              lastCmd: msg.key,
            })

            break
          case "Home":
            state = updateState(state, {
              firstRow: 0,
              lastRow: state.pageSize,
            })
            break
          case "End":
            const count = this.count()
            state = updateState(state, {
              firstRow: count - state.pageSize,
              lastRow: count,
            })
            break
        }
    }
    console.log(`update: updated state:`, state)
    return state
  },

  view(state) {
    // if (state.lastCmd != undefined) {
    //   const offset =
    //     (parseInt(state.firstRow) / parseInt(this.count())) *
    //     this.spacer.getBoundingClientRect().height
    //   console.error(`PageDown: offset:`, offset, this.el)

    //   this.el.scrollTo(0, offset)
    // }

    if (state.firstRow < state.pageSize) {
      // console.error(`scroll to origin:`, this.el)
      this.el.scrollTo(0, 0)
    }

    if (state.firstRow != state.lastFirstRow) {
      // console.log(`view: load-rows?:`, {
      //   start: Math.round(state.firstRow),
      //   stop: Math.round(state.lastRow),
      //   pageSize: state.pageSize,
      // })
      this.pushEvent("load-rows", {
        start: Math.round(state.firstRow),
        stop: Math.round(state.lastRow),
        pageSize: state.pageSize,
      })
    }
    return state
  },

  mounted() {
    this.eventStream = debounceTime(500, flyd.stream())

    this.rowHeights = {}
    this.offsets = {}

    let canvas = first(this.el.findByRole("canvas"))
    if (canvas == undefined) {
      canvas = first(listChildren(this.el))
    }

    this.canvas = canvas

    this.setRowHeights()

    this.tailObserver = new IntersectionObserver(
      (entries, observer) => this.lastEntryHandler(entries, observer),
      {
        root: this.el,
        rootMargin: "-10px",
      }
    )

    this.headObserver = new IntersectionObserver(
      debounce((entries, observer) =>
        this.firstEntryHandler(entries, observer)
      ),
      {
        root: this.el,

        rootMargin: "-50px",
      }
    )

    window.addEventListener("keydown", this.eventStream)
    window.addEventListener("scroll", this.eventStream)
    window.addEventListener("resize", this.eventStream)

    let currentModel = this.init()

    const Messages = filter((msg) => {
      if (["PageDown1", "PageUp1", "Meta"].contains(msg.key)) return false

      return true
    }, this.eventStream)
    Messages.map((msg) => {
      let model = {
        ...currentModel,
      }

      model = this.update(msg, model)
      model = { ...model, ...{ lastFirstRow: currentModel.firstRow } }
      // if (model.firstRow !== currentModel.firstRow) {
      model = this.view(model)
      // } else {
      // console.log(`not updatingview: firstRow unchanged`)
      // }
      currentModel = model
    })

    // console.log(`row count: ${this.count()}`)

    this.createSpacer()
    this.createObservers()
  },

  beforeUpdate() {
    this.setRowHeights()

    const firstVisible = this.firstVisible()

    this.clearObservers()

    this.eventStream({
      type: "set-offset",
      value: this.el.scrollTop,
    })

    this.eventStream({
      type: "set-last-rowstart",
      value: {
        lastRowStart: this.rowStart(),
        lastScrollTop: this.el.scrollTop,
      },
    })
  },

  updated() {
    this.setRowHeights()

    this.clearObservers()
    this.report()
    this.createSpacer()

    this.eventStream({
      type: "offset-canvas",
    })
  },

  destroyed() {},

  setOffset(state) {
    if (state == undefined) return

    if (state.lastRow < 1) return

    const getStart = (start) => (start == undefined || start < 0 ? 0 : start)
    const firstIdx = getStart(this.rowStart())

    if (firstIdx < 2) {
      this.createObservers()
      return
    }

    this.clearObservers()
    const firstVisible = this.firstVisible()
    const lastVisible = this.lastVisible()

    const avg = this.averageRowHeight()

    const offset = avg * (this.rowStart() - 1)

    if (state.lastCmd != undefined) {
      const offset =
        (parseInt(state.firstRow) / parseInt(this.count())) *
        this.spacer.getBoundingClientRect().height
      // console.error(`PageDown: offset:`, offset, this.el)

      this.el.scrollTo(0, offset)
    }

    if (state.firstRow < state.pageSize) {
      // console.error(`scroll to origin:`, this.el)
      this.el.scrollTo(0, 0)
    }

    this.canvas.style = `transform: translateY(${this.el.scrollTop}px)`
    this.createObservers()
  },

  setRowHeights() {
    const children = listChildren(this.canvas)

    const collectOffsets = (c, idx) => {
      const height = [
        c.getBoundingClientRect().height,
        parseInt(window.getComputedStyle(c).marginBottom),
        parseInt(window.getComputedStyle(c).marginTop),
      ].reduce((n, x) => n + x, 0)

      this.rowHeights[this.rowStart() + idx] = height
      this.offsets[this.rowStart() + idx] = c.getBoundingClientRect().top
    }
    children.forEach(collectOffsets)
  },

  clearObservers() {
    listChildren(this.canvas).forEach((c) => {
      this.tailObserver.unobserve(c)
      this.headObserver.unobserve(c)
    })
  },

  createObservers() {
    this.observeTail()
    this.observeHead()
  },

  report() {
    const report = document.getElementById("report")
    if (report != undefined) {
      const avg = this.averageRowHeight()
      report.textContent = `scrollTop: ${this.el.scrollTop} scrollTop - avg ${
        this.el.scrollTop - avg
      } scrollTop + avg ${this.el.scrollTop + avg}`
    }
  },

  rewind(state) {
    const current = this.currentIndexes()
    let start = current.firstVisible - this.scrollAmount()
    if (start < 0) {
      start = 0
    }
    const update = {
      ...state,
      ...current,
      ...{
        firstRow: start,
        lastRow: start + state.pageSize,
      },
    }
    return update
  },

  forward(state) {
    const current = this.currentIndexes()
    const pageSize = state.lastRow - state.firstRow
    const update = {
      ...state,
      ...current,
      ...{
        firstRow: current.firstVisible,
        lastRow: current.firstVisible + pageSize,
      },
    }

    return update
  },

  scrollAmount() {
    const pageSize = this.getPageCount()
    // const children = listChildren(this.canvas)
    // const visible = children.filter((c) => this.isVisible(c))
    // console.log(`scrollAmount: visible: ${visible.length}`)
    // return state.pageSize - 1
    // return Math.ceil(pageSize * 0.66)
    return Math.ceil(pageSize * 0.75)
    // return pageSize - 1
  },

  scrollPage(state) {
    const amount = this.scrollAmount()
    // console.warn(`scrollPage: amount ${amount}`)

    const current = this.currentIndexes()
    const start = state.firstRow + amount < 0 ? 0 : state.firstRow + amount
    if (start > this.count()) {
      return state
    }
    const pageSize =
      state.pageSize === null ? state.lastRow - state.firstRow : state.pageSize
    const lastRow = start + pageSize

    return updateState(state, {
      firstRow: start,
      lastRow: start + pageSize,
    })
  },

  firstVisible() {
    const visible = listChildren(this.canvas).filter((c) => this.isVisible(c))
    return first(visible)
  },

  lastVisible() {
    const visible = listChildren(this.canvas).filter((c) => this.isVisible(c))
    return last(visible)
  },

  currentIndexes() {
    const children = listChildren(this.canvas)
    const visible = children.filter((c) => this.isVisible(c))
    const pageStart = parseInt(this.el.dataset.pageStart)

    const elemIndex = (elem) =>
      children.findIndex((c) => c === elem) + pageStart

    const firstVisible =
      first(visible) == undefined ? 0 : elemIndex(first(visible))
    const lastVisible =
      last(visible) == undefined ? -1 : elemIndex(last(visible))

    return {
      firstRow: pageStart == undefined ? 0 : pageStart,
      lastRow: children.length,
      firstVisible: firstVisible,
      lastVisible: lastVisible,
    }
  },

  lastEntryHandler(entries) {
    const entry = first(entries)
    const target = entry.target

    if (!entry.isIntersecting === true) return

    target.style.backgroundColor = "red"

    this.clearObservers()
    this.eventStream({
      type: "next-page",
      time: entry.time,
    })
  },

  firstEntryHandler(entries) {
    const entry = first(entries)
    const target = entry.target
    if (!entry.isIntersecting === true) return

    target.style.backgroundColor = "orange"

    this.clearObservers()
    this.eventStream({
      type: "previous-page",
      time: entry.time,
    })
  },

  observeTail() {
    const lastChild = last(listChildren(this.canvas))
    if (lastChild === undefined) return

    if (this.isVisible(lastChild)) return

    lastChild.style.backgroundColor = "red"
    this.tailObserver.observe(lastChild)
  },

  observeHead() {
    const firstChild = first(listChildren(this.canvas))
    if (firstChild === undefined) return

    if (this.isVisible(firstChild) && this.rowStart() === 0) {
      firstChild.style.backgroundColor = "gray"
      return
    }
    firstChild.style.backgroundColor = "red"

    this.headObserver.observe(firstChild)
  },

  count() {
    // return parseInt(this.el.dataset.count)
    const count = parseInt(this.el.dataset.count)
    // console.log(`count: ${count}`)
    const columns = this.columnCount()
    // console.log(`columns: ${columns} count / columns: ${count / columns}`)

    // return count / columns
    return count
  },

  rowStart() {
    return parseInt(this.el.dataset.pageStart)
  },

  isVisible(elem) {
    if (elem == undefined) return false
    const outerBounds = this.el.getBoundingClientRect()
    const top = elem.getBoundingClientRect().top
    return top > outerBounds.top && top < outerBounds.bottom
  },

  averageRowHeight() {
    const totalOffsets = Object.keys(this.rowHeights)
      .map((c) => this.rowHeights[parseInt(c)])
      .reduce((n, x) => n + x, 0)
    return Math.ceil(totalOffsets / Object.keys(this.rowHeights).length)
  },

  columnCount() {
    const columns = parseInt(this.el.dataset.columns)
    return columns > 0 ? columns : 1
  },

  getPageCount() {
    const totalOffsets = Object.keys(this.rowHeights)
      .map((c) => this.rowHeights[parseInt(c)])
      .reduce((n, x) => n + x, 0)

    const avg = this.averageRowHeight()
    const children = listChildren(this.canvas)

    const visible = children.filter((c) => this.isVisible(c))
    // console.warn(`visible: ${visible.length}`)

    const columns = this.columnCount()

    const pagesize =
      Math.ceil(this.el.getBoundingClientRect().height / avg) * columns
    // const pagesize2 = children.length
    // const pagesize = pagesize2 < pagesize1 ? pagesize1 : pagesize2

    // console.warn(`pagesize1: height / avg: ${pagesize1}`)
    // console.warn(`pagesize2: children.length: ${pagesize2}`)

    // console.warn(`pageSize: ${pagesize}`)
    return pagesize
  },

  createSpacer() {
    this.el.addClass("relative")
    const spacer = document.createElement("div")

    const heights = Object.values(this.rowHeights)
    let height
    if (heights.length === this.count()) {
      height = heights.reduce((n, x) => n + x, 0)
    }

    const avg = this.averageRowHeight()
    height = height == undefined ? avg * this.count() : height
    spacer.style = `height: ${height}px; position: absolute; width: 2rem; left: 0; top: 0; z-index:-1; background-color: orange;`
    this.spacer = spacer
    this.el.appendChild(spacer)
  },
}
